import React, { FunctionComponent, useMemo } from 'react';
import styles from './icon-with-description.module.scss';

export interface IIconWithDescriptionProps {
  icon: {
    url: string;
    description: string;
  };
  description: string;
  position?: string;
}

export const IconWithDescription: FunctionComponent<IIconWithDescriptionProps> = ({
  icon,
  description,
  position
}) => {
  const itemsPosition = useMemo(() => {
    switch (position) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }, [position]);

  return (
    <div
      className={`${styles.wrapper} ${itemsPosition !== 'center' &&
        styles.fullWidth}`}
      style={{ alignItems: itemsPosition ? itemsPosition : 'center' }}
    >
      <div className={styles.iconWrapper}>
        <img src={icon.url} alt={icon.description} />
      </div>
      <p
        className={`${styles.description} ${itemsPosition !== 'center' &&
          styles.largeSpace}`}
        style={{ textAlign: position ? position : 'center' }}
      >
        {description}
      </p>
    </div>
  );
};
